module.exports = __webpack_public_path__ + "img/crm-2.aa42a02b.jpg";